import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { Button, CircularProgress, Grid, IconButton, makeStyles, Paper, Tooltip, Typography } from "@material-ui/core";
import { Autorenew, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "features/client/styles";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function FiltersWithTaxNumber({ filterLens, onReset, onSearch, loading }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSearch = useCallback(() => onSearch(false), [onSearch]);

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSearch();
      }
    },
    [handleSearch]
  );

  return (
    <Paper className={classes.filterStyle} onKeyUp={handleKeypress}>
      <Grid container>
        <Grid item>
          <Typography>{t("Client.EnterTaxIdOrCompanyNameAndCity")}</Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={4} container justifyContent="center">
          <CustomTextField
            fullWidth
            label={t("Client.TaxIdNumber")}
            value={(filterLens.taxId |> get) || emptyString}
            onChange={filterLens.taxId |> set |> onTextBoxChange}
          />
        </Grid>
        <Grid item xs={12} md={2} container justifyContent="center">
          <Typography variant="caption">{t("Client.OR")}</Typography>
        </Grid>
        <Grid item container xs={12} md={4} justifyContent="center" alignItems="center">
          <CustomTextField
            fullWidth
            label={t("Client.CompanyName")}
            value={(filterLens.companyName |> get) || emptyString}
            onChange={filterLens.companyName |> set |> onTextBoxChange}
          />
          <CustomTextField
            fullWidth
            label={t("Client.CityDistrictCounty")}
            value={(filterLens.cityDistrictCounty |> get) || emptyString}
            onChange={filterLens.cityDistrictCounty |> set |> onTextBoxChange}
          />
        </Grid>
        <Grid item xs={12} md={2} container justifyContent="flex-end">
          <IconButton color="default" onClick={onReset} style={{ marginRight: 10 }}>
            <Tooltip title={t("General.ResetFilter")}>
              <Autorenew fontSize="small" />
            </Tooltip>
          </IconButton>
          <Button
            id="clientSearch_SearchBtn"
            right="true"
            variant="contained"
            color="primary"
            onClick={handleSearch}
            endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
          >
            {t("General.Search")}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

FiltersWithTaxNumber.propTypes = {
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default FiltersWithTaxNumber;
